import { Checkbox } from "../../../components/ui";
import { AlertBanner } from "../../../components/ui/AlertBanner";
import { CheckCircleIcon, PaymentCashIcon, PaymentLoyaltyIcon } from "../../../icons";
import useLoyaltyStore from "../../../store/loyaltyStore";
import usePersonStore from "../../../store/personStore";

export const BookingStepFive = ({ state, dispatch }) => {
  // Step One: Here the user chooses the types of services
  // he/she wants to book an appointment for.
  
  // GLOBAL STATE:
  const loyaltyInfo = usePersonStore((store) => store.loyaltyInfo);
  const { isLoyaltyEligible, isLoyaltyEnrolled } = usePersonStore.getState();
  const { loyaltyProducts } = useLoyaltyStore.getState()
  
  // LOCAL STATE:
  const productPickupCost = loyaltyProducts?.filter((product) => product?.name === "Pick-Up & Delivery")?.[0]?.redemptionPoints
  const disabledMiles = state?.loyaltyCost ===null || state?.loyaltyCost === undefined || state?.loyaltyCost > loyaltyInfo?.awardPoints
  // FETCH DATA:

  // LOCAL VARIABLES:

  // USE EFFECTS:

  // HANDLERS & FUNCTIONS

  return (
    <div className = 'flex flex-col gap-6'>
      <div>
        <p className={`text-lg font-bold`}>{isLoyaltyEligible && isLoyaltyEnrolled ? "Πώς θέλεις να πληρώσεις;" : "Ολοκλήρωση πληρωμής"}</p>
        {isLoyaltyEligible && isLoyaltyEnrolled && <p className={`text-lg`}>Πλήρωσε εύκολα με κάρτα ή εξαργύρωσε χιλιόμετρα.</p>}
      </div>
      <div className='grid grid-cols-2 gap-3 max-lg:grid-cols-1'>
        <div className={`bg-white flex flex-col gap-2 w-full p-6 cursor-pointer rounded-xl ${state?.selectedPayment === "cash" ? "border outline outline-2 outline-[#070707] border-[#070707]" : "border-[1px] border-fadedgrey"}`}
          onClick={()=> {
            dispatch({ type: "SET_SELECTED_PAYMENT", selectedPayment: 'cash' });
          }
        }>
          <PaymentCashIcon />
          <p className={`text-lg font-bold`}>Πληρωμή με κάρτα {state?.pickupCost}€</p>
          <p className={`text-sm`}>Διαθέσιμες κάρτες χρεωστικές ή πιστωτικές, VISA, MasterCard</p>
        </div>
        {isLoyaltyEligible && isLoyaltyEnrolled && <div className={`bg-white flex flex-col gap-2 w-full p-6 cursor-pointer rounded-xl ${state?.selectedPayment === "loyaltyPoints" ? "border outline outline-2 outline-[#070707] border-[#070707]" : " border-[1px] border-fadedgrey"}`}
          onClick={()=> {
            if(!disabledMiles) {
              dispatch({ type: "SET_SELECTED_PAYMENT", selectedPayment: 'loyaltyPoints' });
            }
          }}>
            <PaymentLoyaltyIcon />
            <div className='flex flex-col gap-2'>
              <p className={`text-lg font-bold ${disabledMiles ? "text-fadedgrey" : "text-black"}`}>Εξαργύρωση {(state?.loyaltyCost ?? productPickupCost)?.toLocaleString("el-GR")} χλμ</p>
              <p className={`text-sm ${disabledMiles ? "text-fadedgrey" : "text-black"}`}>Διαθέσιμα προς εξαργύρωση {(loyaltyInfo?.awardPoints)?.toLocaleString("el-GR")} χιλιόμετρα</p>
            </div>
        </div>}
      </div>
      {isLoyaltyEligible && isLoyaltyEnrolled && (
        disabledMiles ? <AlertBanner severity="disabled" className='pb-1'>
        <div className='flex flex-row gap-[14px] justify-start align-top p-3'>
          <CheckCircleIcon width='20' height='20' className={'stroke-[#8F8F8F] shrink-0'} />
          <p className='text-sm font-semibold'>Συνέχισε να συγκεντρώνεις χιλιόμετρα στο Avis More για να απολαύσεις δωρεάν την υπηρεσία Pick-Up & Delivery.</p>
        </div>
      </AlertBanner>
      : <AlertBanner severity="info" className='pb-1'>
        <div className='flex flex-row gap-[14px] justify-start align-top p-3'>
          <CheckCircleIcon width='20' height='20' className={'stroke-[#2E9BFF] shrink-0'} />
          <p className='text-sm font-semibold'>Εξαργύρωσε τα χιλιόμετρά σου στο Avis More και απόλαυσε δωρεάν την υπηρεσία Pick-Up & Delivery.</p>
        </div>
      </AlertBanner>
      )}
      <div className="fixed bottom-0 right-0 z-50 lg:w-[calc(100vw-378px)] max-lg:w-full">
        <div className="lg:mx-auto w-full lg:max-w-[880px] px-5">
          <div className="bg-white/95 backdrop-blur border border-[#E2E2E2] rounded-t-[12px] shadow-[0_4px_12px_rgba(0,0,0,0.12)]">
            <div className="flex items-center justify-between pt-6 pb-7 px-6 md:px-12">
              <p className="text-xl font-bold text-[#2c2c2c]">Συνολικό ποσό</p>
              <p className="text-xl font-bold text-[#2c2c2c]">
                {state?.selectedPayment === "cash"
                  ? `${state?.pickupCost}€`
                  : state?.selectedPayment === "loyaltyPoints"
                    ? `${(state?.loyaltyCost)?.toLocaleString("el-GR")} χλμ`
                    : ""}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* {state?.showInvoiceOption && state?.selectedPayment === 'cash' && <div className='flex flex-row gap-2 items-center'>
        <Checkbox
          checked={state?.hasSelectedInvoice}
          onCheckedChange={() => {dispatch({ type: "SET_HAS_SELECTED_INVOICE", hasSelectedInvoice: !state?.hasSelectedInvoice});}}
          className='h-5 w-5'
        />
        <p>Θα ήθελα έκδοση τιμολογίου</p>
      </div>} */}
    </div>
  );
};
